<template>
    <div class="card mb-2">
        <div class="card-header pr-1 d-flex align-items-center">
            <span class="btnlike mr-auto">
                <h4 class="mb-0">ACA</h4>
            </span>

            <button v-if="canEdit" class="btn btn-outline-primary" type="button" @click.prevent="editACA">
                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                Edit
            </button>
        </div>

        <div class="card-body">
            <div class="mui-textfield">
                <span class="textfield">{{ employee.aca_category }}</span>
                <label>ACA Employment Category</label>
            </div>
        </div>
    </div>

    <EditACAModal
        :employee="employee"
        :client="client"
        v-if="editACAModalOpened"
        @updated="onUpdate"
        @close="editACAModalOpened = false"
    />
</template>

<script>

import ButtonRow from '@/components/ButtonRow.vue'
import EditACAModal from './EditEmployeeACAModal.vue'

export default {
    props: ['employee', 'client'],
    emits: ['updated'],
    components: {ButtonRow, EditACAModal},
    data() {
        return {
            editACAModalOpened: false
        }
    },
    computed: {
        canEdit() {
            if (this.employee.is_employee && !this.$permissions.hasRolesInCompany(this.client.id, this.employee.company_id, this.$store.state.security_roles.EMPLOYEE_ROLES)) {
                return false  // Onboarding-only managers can't edit existing employees
            }
            return this.employee.is_employee || (this.employee.is_onboarding_application && this.employee.status != 'canceled')
        },
    },
    methods: {
        editACA() {
            this.editACAModalOpened = true
        },
        onUpdate() {
            this.$emit('updated')
        },
    },
}
</script>
